/* eslint-disable guard-for-in */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */

import './vendor';
import './helpers';
import social from './components/social';
import './components/analytics';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
// import lazyLoading from './modules/lazyLoading';
// import scrollToAnchor from './modules/scrollToAnchor';
import {museums} from './db/museums';
import {Content} from './components/Content';
import {PopupList} from './components/PopupList';
import {Search} from './components/Search';

ieFix();
vhFix();
actualYear();
social.init();

// lazyLoading.init();
const isModile = window.innerWidth < 850;
const popup = new Content();
const search = new Search(museums);
const popupList = new PopupList(museums); // eslint-disable-line

// список областей и городов для открытия рубрикатором
const listOpen = ['moscowOld', 'spbOld', 'tula-obl'];

document.addEventListener('DOMContentLoaded', () => {
	if (isModile) {
		const mapHeight = $('.map__icon').height();
		$('.map__icon').closest('.container').scrollTop(mapHeight - 400);
		setTimeout(() => {
			document.querySelector(".home .container").addEventListener("scroll", () => {
				document.querySelector(".map__swipe").classList.add("hide");
			});
		}, 500);
	}
});

document.addEventListener('click', (e) => {
	// открытие рубрикатора по клику
	if (isModile) {
		if (e.target.closest('.map__icon') && e.target.id) {
			// popup.open();
			// popup.get(search.clickSearch(e), museums);
			search.clickSearch(e);
			ga('send', 'event', 'map', 'show museum list', e.target.getAttribute('data-name'));
		}
	} else if (listOpen.indexOf(e.target.id) !== -1) {
		popupList.close();
		popup.open();
		popup.get(search.clickSearch(e), museums);
		ga('send', 'event', 'map', 'detail popup open',
			`${e.target.getAttribute('data-name')} - ${museums[search.clickSearch(e)].name.replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')}`);
	}

	// закрытие попапа с музеями по городу
	if (!e.target.closest('.map__icon') && !e.target.closest('.popup-list')) {
		popupList.close();
	}

	// открытие попапа контента из попапа с музеями по городу
	if (e.target.closest('.popup-list__item')) {
		const parentEl = e.target.closest('.popup-list__item');
		let id = parentEl.dataset.id ? parentEl.dataset.id : parentEl.id;
		let location = parentEl.getAttribute('data-location-name');
		let name = parentEl.textContent.trim();
		const type = parentEl.dataset.type;
		const parentId = parentEl.dataset.parentId;

		if (parentId) {
			id = parentId;
		}

		setTimeout(() => {
			const offsetTop = document.getElementById(id).offsetTop;
			$('.header__search-wrapper').scrollTop(offsetTop - 100);
		}, 1000);

		popup.get(id, museums);
		search.clickSearch(e);
		popup.open();
		search.open();
		popupList.close();

		ga('send', 'event', 'map', 'go item museum list', parentEl.getAttribute('data-location-name'));
		ga('send', 'event', 'map', 'detail popup open', `${location} - ${name}`);
	}

	// открытие попапа контента из поиска
	if (e.target.closest('.header__search-result-item')) {
		const parentEl = e.target.closest('.header__search-result-item');
		const id = parentEl.id;

		if (museums[id].parentId) {
			popup.get(museums[id].parentId, museums);
		} else {
			popup.get(id, museums);
		}

		if (isModile) {
			search.close();
			// search.getMuseums(museums);
			// search.filter(null, museums);
		}

		const name = e.target.closest('.header__search-result-item').querySelector('.header__search-result-item-name').textContent;
		const location = e.target.closest('.header__search-result-item').querySelector('.header__search-result-item-location').textContent;
		const filterTitle = document.querySelector('.filter__title').textContent;

		ga('send', 'event', 'map', 'left menu click', `${filterTitle} - ${name}`);
		ga('send', 'event', 'map', 'detail popup open', `${location} - ${name}`);

		document.querySelector('.popup-content__location').addEventListener('click', () => {
			ga('send', 'event', 'map', 'detail popup museum address', `${location} - ${name}`);
		});

		document.querySelector('.popup-content__link').addEventListener('click', () => {
			ga('send', 'event', 'map', 'detail popup museum link', `${location} - ${name}`);
		});
	}

	if (
		!isModile &&
		!e.target.closest('.popup-content') &&
		!e.target.closest('.header__wrapper') &&
		!e.target.closest('.map__icon') &&
		!e.target.closest('.popup-list')
	) {
		search.close();
		popup.close();
	}
});

window.addEventListener('resize', () => {
	popup.resize();
}, false);
